<template>
  <ul v-if="hasMainMenuOpen || isMobileDevice" class="submenu">
    <li v-for="item in items" :key="`subitem-${item.title}`" v-show="item.visible">
      <router-link :to="{ name: item.route.name }">
        {{ $t(`${namespace}.${item.title}`) }}
      </router-link>
    </li>
  </ul>
</template>

<script>
import { mapState } from 'vuex'
import mediaQueries from 'mixins/mediaQueries'

export default {
  name: 'MenuDropdownItems',
  mixins: [mediaQueries],
  props: {
    items: {
      type: Array,
      require: true
    }
  },
  computed: {
    ...mapState({
      hasMainMenuOpen: ({ mainMenu }) => mainMenu.isOpen
    }),

    isMobileDevice () {
      return this.isMobile || this.isTablet
    }
  },
  data () {
    return {
      namespace: 'Components.MainMenu'
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>
